import {
    PASSAGE,
    QUESTIONS,
    ITEMS,
    OPENING,
    PRACTICE,
    INSTRUCTIONS,
    MODEL,
    SCROLL,
    COUNTDOWN,
    READING,
    BOOK,
    DIRECTIONS,
    REMINDERS,
} from './assessmentItemType';

import { WR, CLPL as CLPL_MEASURE } from './measure';

/* LOCATION CONSTANTS */
export const ROOT = '/';
export const APP_ROOT_PATH = 'student-assessment';
export const STUDENT_ASSESSMENT = `${ROOT}${APP_ROOT_PATH}`;
export const STUDENT = `${ROOT}student`;
export const START = `${STUDENT_ASSESSMENT}/start`;
export const DONE = `${STUDENT_ASSESSMENT}/done`;
export const INTERSTITIAL = `${STUDENT_ASSESSMENT}/interstitial`;
export const ANY_PATH = '*';
export const OWLY_INTERSTITIAL = `${STUDENT_ASSESSMENT}/owlyInterstitial`;

export const START_PAGE_URLS = [STUDENT_ASSESSMENT, START, `${STUDENT_ASSESSMENT}/`, `${START}/`];
export const LANDING_PAGES = START_PAGE_URLS;

/* Word Reading */
export const WR_BASE = `${STUDENT_ASSESSMENT}/${WR.KEY}`;
export const WR_OPENING = `${WR_BASE}/${OPENING}`;
export const WR_MODEL = `${WR_BASE}/${MODEL}`;
export const WR_PRACTICE = `${WR_BASE}/${PRACTICE}`;
export const WR_COUNTDOWN = `${WR_BASE}/${COUNTDOWN}`;
export const WR_QUESTIONS = `${WR_BASE}/${QUESTIONS}/:questionIndex`;
/* Maze */
export const MAZE = `${STUDENT_ASSESSMENT}/maze`;
export const MAZE_MODEL = `${MAZE}/${MODEL}`;
export const MAZE_PASSAGE = `${MAZE}/${PASSAGE}`;
export const MAZE_MODEL_SCROLL = `${MAZE}/${SCROLL}`;
export const MAZE_PRACTICE = `${MAZE}/${PRACTICE}`;
export const MAZE_INSTRUCTIONS = `${MAZE}/${INSTRUCTIONS}`;
export const MAZE_COUNTDOWN = `${MAZE}/${COUNTDOWN}`;
/* Cual Palabra */
export const CLPL = `${STUDENT_ASSESSMENT}/${CLPL_MEASURE.ASSESSMENT}`;
export const CLPL_MODEL = `${CLPL}/${MODEL}`;
export const CLPL_PASSAGE = `${CLPL}/${PASSAGE}`;
export const CLPL_MODEL_SCROLL = `${CLPL}/${SCROLL}`;
export const CLPL_PRACTICE = `${CLPL}/${PRACTICE}`;
export const CLPL_INSTRUCTIONS = `${CLPL}/${INSTRUCTIONS}`;
export const CLPL_COUNTDOWN = `${CLPL}/${COUNTDOWN}`;
/* TRC */
export const TRC = `${STUDENT_ASSESSMENT}/trc`;
export const TRO_INSTRUCTIONS = `${TRC}/${INSTRUCTIONS}`;
export const TRO_REMINDERS = `${TRC}/${REMINDERS}`;
export const TRC_BOOK_START = `${TRC}/${BOOK}`;
export const TRC_COUNTDOWN = `${TRC}/${COUNTDOWN}`;
export const TRC_READING = `${TRC}/${READING}`;
export const TRC_QUESTIONS = `${TRC}/${QUESTIONS}/:questionIndex`;

/* VOCAB */
export const VOCAB = `${STUDENT_ASSESSMENT}/vocab`;

export const VOCAB_TQVM = `${VOCAB}/tqvm`;
export const VOCAB_TQVM_PRACTICE = `${VOCAB_TQVM}/${PRACTICE}`;
export const VOCAB_TQVM_COUNTDOWN = `${VOCAB_TQVM}/${COUNTDOWN}`;
export const VOCAB_TQVM_QUESTIONS = `${VOCAB_TQVM}/${QUESTIONS}/:questionIndex`;
export const VOCAB_FITB = `${VOCAB}/fitb`;
export const VOCAB_FITB_PRACTICE = `${VOCAB_FITB}/${PRACTICE}`;
export const VOCAB_FITB_COUNTDOWN = `${VOCAB_FITB}/${COUNTDOWN}`;
export const VOCAB_FITB_QUESTIONS = `${VOCAB_FITB}/${QUESTIONS}/:questionIndex`;
export const VOCAB_BD = `${VOCAB}/bd`;
export const VOCAB_BD_PRACTICE = `${VOCAB_BD}/${PRACTICE}`;
export const VOCAB_BD_COUNTDOWN = `${VOCAB_BD}/${COUNTDOWN}`;
export const VOCAB_BD_QUESTIONS = `${VOCAB_BD}/${QUESTIONS}/:questionIndex`;

/* SPELLING */
export const SPELLING = `${STUDENT_ASSESSMENT}/spelling`;
export const SPELLING_PRACTICE = `${SPELLING}/${PRACTICE}`;
export const SPELLING_COUNTDOWN = `${SPELLING}/${COUNTDOWN}`;
export const SPELLING_QUESTIONS = `${SPELLING}/${QUESTIONS}/:questionIndex`;

/* RAN */
export const RAN = `${STUDENT_ASSESSMENT}/ran`;
export const RAN_NUMBERS = `${RAN}/numbers`;
export const RAN_NUMBERS_PRACTICE = `${RAN_NUMBERS}/${PRACTICE}`;
export const RAN_NUMBERS_COUNTDOWN = `${RAN_NUMBERS}/${COUNTDOWN}`;
export const RAN_NUMBERS_ITEMS = `${RAN_NUMBERS}/${ITEMS}`;
export const RAN_NUMBERS_DIRECTIONS = `${RAN_NUMBERS}/${DIRECTIONS}`;

/* LC */
export const LC = `${STUDENT_ASSESSMENT}/lc`;
export const LC_QUESTIONS = `${LC}/${QUESTIONS}/:questionIndex`;
export const LC_READING = `${LC}/${READING}`;

/* External Sites */
export const PORTAL = 'portal';
export const PORTAL_DASHBOARD = `${ROOT}${PORTAL}/`;

export const PAGES_WITH_CAPTIONS = [
    MAZE_MODEL,
    MAZE_MODEL_SCROLL,
    MAZE_PRACTICE,
    MAZE_INSTRUCTIONS,
    CLPL_MODEL,
    CLPL_MODEL_SCROLL,
    CLPL_PRACTICE,
    CLPL_INSTRUCTIONS,
    WR_MODEL,
    WR_PRACTICE,
    WR_OPENING,
    WR_QUESTIONS,
    VOCAB_TQVM_PRACTICE,
    VOCAB_TQVM_QUESTIONS,
    VOCAB_FITB_PRACTICE,
    VOCAB_FITB_QUESTIONS,
    VOCAB_BD_PRACTICE,
    VOCAB_BD_QUESTIONS,
    SPELLING_PRACTICE,
    SPELLING_QUESTIONS,
    RAN_NUMBERS_PRACTICE,
    RAN_NUMBERS_DIRECTIONS,
];
export const PAGES_WITH_MAIN_NAVIGATION_AND_SUBHEADER = START_PAGE_URLS.concat([
    DONE,
    `${DONE}/`,
    TRC_BOOK_START,
]);

export const AR_CI_URL = 'https://reading.ar.ci.amplify.com';
export const CI_URL = 'https://mclass.ci.amplify.com';

export const QUIT_SEB_URL = '/quit-seb';
